import React from 'react'
import { useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { LinkBlock } from 'apps/optIn/components/LinkBlock'
import { PreviewBlocksAvatar } from 'apps/optIn/components/PreviewBlocksAvatar'
import { getIsIgPreviewBlockQrEnabled } from 'common/core/selectors/appSelectors'

import { IgPreviewHowTo } from './IgPreviewHowTo'
import { IgQrDmUrl } from './IgQrDmUrl'

import cm from './IgPreviewBlock.module.css'

export interface IgPreviewBlockProps {
  dataTestId: string
  info: {
    username: string
    avatar_url: string | null
    dm_url?: string
  }
  keyword?: string
  has_otnr: boolean
}

export function IgPreviewBlock(props: IgPreviewBlockProps) {
  const isIgPreviewBlockQrEnabled = useAppSelector(getIsIgPreviewBlockQrEnabled)

  const keywordLayout = props.keyword ? (
    <>
      <span className="d-block m-t m-b-xs">
        {isIgPreviewBlockQrEnabled ? (
          <div>
            <IgQrDmUrl url={props.info.dm_url} />
            <div className="m-y-xs">
              {l.translate(
                'Scan QR code to open Direct Message with <b>{igAccountName}</b>. And send a message with this 3-digits code:',
                {
                  igAccountName: props.info.username,
                },
              )}
            </div>
          </div>
        ) : (
          <div>
            {l.translate(
              'Open Instagram and send a Direct Message with this three-digits code to your <b>@{igAccountName}</b> account from a different IG account',
              {
                igAccountName: props.info.username,
              },
            )}
          </div>
        )}
      </span>
      <span className="d-block bg-default p-y-xxs text-heading-2 text-black text-center rounded">
        {props.keyword}
      </span>
    </>
  ) : null

  return (
    <div data-test-id={props.dataTestId} className="d-flex">
      <PreviewBlocksAvatar url={props.info.avatar_url ?? undefined} />
      <div className={cm.content}>
        <span className="text-subheading d-block font-semibold">{l.translate('Instagram')}</span>
        <span className="d-block">{props.info.username}</span>
        {keywordLayout}
        {!isIgPreviewBlockQrEnabled && <IgPreviewHowTo keyword={props.keyword} />}
        {props.has_otnr && (
          <LinkBlock
            dataTestId="otn-preview-block"
            text={l.translate(
              'We send you a not real request in the preview to verify that everything is working correctly.',
            )}
          />
        )}
      </div>
    </div>
  )
}
